// @ts-nocheck
import React, { forwardRef } from 'react'
import Loader from 'react-loader-spinner'
import cx from 'classnames'
import { debounce } from 'debounce'

import s from './Button.module.css'

interface Props {
  style?: React.CSSProperties
  text: string | React.ReactElement
  onClick?: () => void
  type?: HTMLButtonElement['type']
  isLoading?: boolean
  disabled?: boolean
  className?: string
  variant?: 'active' | 'passive' | 'danger'
  debounced?: boolean
  ghost?: boolean
  isActive?: boolean
}

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      style,
      text,
      onClick = () => {},
      type = 'button',
      isLoading = false,
      disabled,
      className,
      debounced,
      ghost = false,
      isActive = false,
      variant = ''
    },
    ref
  ) => {
    const buttonClass = cx(s.button, {
      [className]: className,
      [s['button--disabled']]: disabled,
      [s['button--isChosen']]: isActive,
      [s['button--loading']]: isLoading,
      [s['button--ghost']]: ghost,
      [s['button--active']]: variant === 'active',
      [s['button--danger']]: variant === 'danger'
    })

    const debouncedClick = debounced ? debounce(onClick, 200) : onClick

    return (
      <button
        ref={ref}
        style={style}
        type={type}
        disabled={isLoading || disabled}
        onClick={disabled || isLoading ? () => {} : debouncedClick}
        className={buttonClass}
      >
        {isLoading ? (
          <Loader
            type="Oval"
            color={disabled ? 'black' : 'white'}
            height={30}
            width={30}
          />
        ) : (
          text
        )}
      </button>
    )
  }
)

export default Button
